<template>
  <b-modal id="bv-modal-checkin-maker" size="sm" hide-header hide-footer centered @shown="onShown">
    <div class="d-block text-center">
      <div class="row">
        <div class="col-12">
          <div>
            <Icon name="grTextInput" width="36" class="mb-3"/>
            <h1 class="modal-title mb-2">{{ $t('pages.checkins.tips_modal_title') }}</h1>
            <h4 class="modal-subtitle mb-3">{{ $t('pages.checkins.tips_modal_subtitle') }}</h4>
          </div>
          <CheckinMaker ref="checkinMaker"/>
        </div>
      </div>
    </div>
  </b-modal>
</template>


<script>
import CheckinMaker from '@/domain/checkin/CheckinMaker'

export default {
  components: {
    CheckinMaker,
  },
  methods: {
    onShown() {
      this.$refs.checkinMaker.$refs.inputPicacode.focus()
    }
  }
}
</script>
